export default __webpack_public_path__ + "static/media/flatBox.c72fdb39.svg";